(function ($) {
  $(document).ready(function () {
    setTimeout(() => {
      console.log('✅ Initializing Slick...');
      if (typeof $.fn.slick !== 'function') {
        console.error('❌ Slick is not available!');
        return;
      }
      $('.scanlab_data_slider .slider').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
        dots: false,
        focusOnSelect: false,
        infinite: false,
        variableWidth: true,
        rows: 0,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              dots: true,
              variableWidth: true,
              arrows: false,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrows: false,
              variableWidth: false,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrows: false,
              variableWidth: false,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              variableWidth: false,
              dots: true,
            },
          },
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              variableWidth: false,
              dots: true,
            },
          },
        ],

      });
    }, 2000);
  });
})(jQuery);